module.exports = __webpack_public_path__ + "public/images/search-white-icon.e8b28b22b092369ec92d8185d2e5dcd5.svg";